"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

export const ClientEventIntervalRefetcher = () => {
  const router = useRouter();

  useEffect(() => {
    const i = setInterval(() => {
      router.refresh();
    }, 10000);
    return () => clearInterval(i);
  }, [router]);

  return null;
};
